<template>
  <section id="gallery" class="gallery">
    <p>{{ $t('offer_projectCreated_inDreamFlat') }}</p>
    <h1>{{ $t('offer_success_cases') }}</h1>
    <UiSliderCustom :items="galleryList" />
  </section>
</template>

<script setup lang="ts">
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

const itemsPoster = ref<{videoSrc: string; value: string}[]>([]);
const galleryList = [
  {
    name: 'offer_all',
    content: [
      {
        id: 1,
        title: 'Bizar',
        description:
          'offer_all_desc1',
        images: [
          `${staticUrl}/images/offer/gallery/for_all/bizar/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/for_all/bizar/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/for_all/bizar/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/for_all_bizar_1.mp4`],
          [`${staticUrl}/video/for_all_bizar_2.mp4`],
          [`${staticUrl}/video/for_all_bizar_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/for_all_bizar_1_mobile.mp4`],
          [`${staticUrl}/video/for_all_bizar_2_mobile.mp4`],
          [`${staticUrl}/video/for_all_bizar_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_20.02.2024_18-00-14-213/index.htm?n=2',
        poster: [
          {
            videoSrc: `${staticUrl}/video/for_all_bizar_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/for_all/bizar/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/for_all_bizar_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/for_all/bizar/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/for_all_bizar_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/for_all/bizar/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 2,
        title: 'S.E.A',
        description:
          'offer_all_desc2',
        images: [
          `${staticUrl}/images/offer/gallery/for_all/sea/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/for_all/sea/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/for_all/sea/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/for_all_sea_1.mp4`],
          [`${staticUrl}/video/for_all_sea_2.mp4`],
          [`${staticUrl}/video/for_all_sea_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/for_all_sea_1_mobile.mp4`],
          [`${staticUrl}/video/for_all_sea_2_mobile.mp4`],
          [`${staticUrl}/video/for_all_sea_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_20.02.2024_18-52-02-942/index.htm?n=2',
        poster: [
          {
            videoSrc: `${staticUrl}/video/for_all_sea_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/for_all/sea/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/for_all_sea_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/for_all/sea/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/for_all_sea_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/for_all/sea/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 3,
        title: 'Olga Poletaeva',
        description:
          'offer_all_desc3',
        images: [
          `${staticUrl}/images/offer/gallery/for_all/olga_poletaeva/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/for_all/olga_poletaeva/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/for_all/olga_poletaeva/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/for_all_olga_poletaeva_1.mp4`],
          [`${staticUrl}/video/for_all_olga_poletaeva_2.mp4`],
          [`${staticUrl}/video/for_all_olga_poletaeva_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/for_all_olga_poletaeva_1_mobile.mp4`],
          [`${staticUrl}/video/for_all_olga_poletaeva_2_mobile.mp4`],
          [`${staticUrl}/video/for_all_olga_poletaeva_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_20.02.2024_19-20-10-738/index.htm?n=1',
        poster: [
          {
            videoSrc: `${staticUrl}/video/for_all_olga_poletaeva_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/for_all/olga_poletaeva/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/for_all_olga_poletaeva_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/for_all/olga_poletaeva/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/for_all_olga_poletaeva_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/for_all/olga_poletaeva/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 4,
        title: 'Mall',
        description:
          'offer_all_desc4',
        images: [
          `${staticUrl}/images/offer/gallery/for_all/mall/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/for_all/mall/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/for_all/mall/photo/photo3.webp`,
        ],
        video: [],
        videoMobile: [],
        tour: '/tours/Tour_from_20.02.2024_18-53-57-833/index.htm?n=3',
        poster: [
          {
            videoSrc: ``,
            value: `${staticUrl}/images/for_all/mall/photo/photo1.webp`,
          },
          {
            videoSrc: ``,
            value: `${staticUrl}/images/for_all/mall/photo/photo2.webp`,
          },
          {
            videoSrc: ``,
            value: `${staticUrl}/images/for_all/mall/photo/photo3.webp`,
          },
        ],
      },
    ],
  },
  {
    name: 'offer_des',
    content: [
      {
        id: 1,
        title: 'Stacy Bezushko',
        description:
          'offer_des_desc1',
        images: [
          `${staticUrl}/images/offer/gallery/designers/stacy_bezushko/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/designers/stacy_bezushko/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/designers/stacy_bezushko/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/designers_stacy_bezushko_1.mp4`],
          [`${staticUrl}/video/designers_stacy_bezushko_2.mp4`],
          [`${staticUrl}/video/designers_stacy_bezushko_3.mp4`],
        ],
        videoMobile: [
          [
            `${staticUrl}/video/designers_stacy_bezushko_1_mobile.mp4`,
          ],
          [
            `${staticUrl}/video/designers_stacy_bezushko_2_mobile.mp4`,
          ],
          [
            `${staticUrl}/video/designers_stacy_bezushko_3_mobile.mp4`,
          ],
        ],
        tour: '/tours/Tour_from_16.02.2024_11-56-58-014/index.htm?n=1',
        poster: [
          {
            videoSrc: `${staticUrl}/video/designers_stacy_bezushko_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/stacy_bezushko/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/designers_stacy_bezushko_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/stacy_bezushko/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/designers_stacy_bezushko_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/stacy_bezushko/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 2,
        title: 'Oleg Nameles',
        description:
          'offer_des_desc2',
        images: [
          `${staticUrl}/images/offer/gallery/designers/oleg_nameles/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/designers/oleg_nameles/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/designers/oleg_nameles/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/designers_oleg_nameles_1.mp4`],
          [`${staticUrl}/video/designers_oleg_nameles_2.mp4`],
          [`${staticUrl}/video/designers_oleg_nameles_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/designers_oleg_nameles_1_mobile.mp4`],
          [`${staticUrl}/video/designers_oleg_nameles_2_mobile.mp4`],
          [`${staticUrl}/video/designers_oleg_nameles_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_16.02.2024_12-28-48-079/index.htm?n=1',
        poster: [
          {
            videoSrc: `${staticUrl}/video/designers_oleg_nameles_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/oleg_nameles/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/designers_oleg_nameles_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/oleg_nameles/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/designers_oleg_nameles_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/oleg_nameles/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 3,
        title: 'NIKA KRYZ',
        description:
          'offer_des_desc3',
        images: [
          `${staticUrl}/images/offer/gallery/designers/nika_kryz/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/designers/nika_kryz/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/designers/nika_kryz/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/designers_nika_kryz_1.mp4`],
          [`${staticUrl}/video/designers_nika_kryz_2.mp4`],
          [`${staticUrl}/video/designers_nika_kryz_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/designers_nika_kryz_1_mobile.mp4`],
          [`${staticUrl}/video/designers_nika_kryz_2_mobile.mp4`],
          [`${staticUrl}/video/designers_nika_kryz_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_19.02.2024_17-10-20-620/index.htm?n=2',
        poster: [
          {
            videoSrc: `${staticUrl}/video/designers_nika_kryz_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/nika_kryz/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/designers_nika_kryz_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/nika_kryz/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/designers_nika_kryz_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/nika_kryz/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 4,
        title: 'Katelav',
        description:
          'offer_des_desc4',
        images: [
          `${staticUrl}/images/offer/gallery/designers/katelav/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/designers/katelav/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/designers/katelav/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/designers_katelav_1.mp4`],
          [`${staticUrl}/video/designers_katelav_2.mp4`],
          [`${staticUrl}/video/designers_katelav_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/designers_katelav_1_mobile.mp4`],
          [`${staticUrl}/video/designers_katelav_2_mobile.mp4`],
          [`${staticUrl}/video/designers_katelav_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_16.02.2024_13-19-48-057/index.htm?n=1',
        poster: [
          {
            videoSrc: `${staticUrl}/video/designers_katelav_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/katelav/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/designers_katelav_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/katelav/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/designers_katelav_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/designers/katelav/photo/photo3.webp`,
          },
        ],
      },
    ],
  },
  {
    name: 'offer_dev',
    content: [
      {
        id: 1,
        title: 'OSUS P121',
        description:
          'offer_dev_desc1',
        images: [
          `${staticUrl}/images/offer/gallery/developers/osus_p121/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/developers/osus_p121/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/developers/osus_p121/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/developers_osup_p121_1.mp4`],
          [`${staticUrl}/video/developers_osup_p121_2.mp4`],
          [`${staticUrl}/video/developers_osup_p121_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/developers_osup_p121_1_mobile.mp4`],
          [`${staticUrl}/video/developers_osup_p121_2_mobile.mp4`],
          [`${staticUrl}/video/developers_osup_p121_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_11.12.2023_16-51-37-950/index.htm?n=3',
        poster: [
          {
            videoSrc: `${staticUrl}/video/developers_osup_p121_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/osus_p121/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/developers_osup_p121_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/osus_p121/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/developers_osup_p121_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/osus_p121/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 2,
        title: 'Yakovlevo',
        description:
          'offer_dev_desc2',
        images: [
          `${staticUrl}/images/offer/gallery/developers/yakovlevo/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/developers/yakovlevo/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/developers/yakovlevo/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/developers_yakovlevo_1.mp4`],
          [`${staticUrl}/video/developers_yakovlevo_2.mp4`],
          [`${staticUrl}/video/developers_yakovlevo_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/developers_yakovlevo_1_mobile.mp4`],
          [`${staticUrl}/video/developers_yakovlevo_2_mobile.mp4`],
          [`${staticUrl}/video/developers_yakovlevo_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_22.08.2023_10-47-07-047/index.htm?n=2',
        poster: [
          {
            videoSrc: `${staticUrl}/video/developers_yakovlevo_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/yakovlevo/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/developers_yakovlevo_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/yakovlevo/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/developers_yakovlevo_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/yakovlevo/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 3,
        title: 'Stockholm',
        description:
          'offer_dev_desc3',
        images: [
          `${staticUrl}/images/offer/gallery/developers/stockholm/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/developers/stockholm/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/developers/stockholm/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/developers_stockholm_1.mp4`],
          [`${staticUrl}/video/developers_stockholm_2.mp4`],
          [`${staticUrl}/video/developers_stockholm_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/developers_stockholm_1_mobile.mp4`],
          [`${staticUrl}/video/developers_stockholm_2_mobile.mp4`],
          [`${staticUrl}/video/developers_stockholm_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_19.02.2024_18-26-44-992/index.htm?n=2',
        poster: [
          {
            videoSrc: `${staticUrl}/video/developers_stockholm_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/stockholm/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/developers_stockholm_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/stockholm/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/developers_stockholm_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/stockholm/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 4,
        title: 'Nikea House',
        description:
          'offer_dev_desc4',
        images: [
          `${staticUrl}/images/offer/gallery/developers/nikea_house/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/developers/nikea_house/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/developers/nikea_house/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/developers_nikea_house_1.mp4`],
          [`${staticUrl}/video/developers_nikea_house_2.mp4`],
          [`${staticUrl}/video/developers_nikea_house_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/developers_nikea_house_1_mobile.mp4`],
          [`${staticUrl}/video/developers_nikea_house_2_mobile.mp4`],
          [`${staticUrl}/video/developers_nikea_house_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_10.11.2023_18-01-12-315/index.htm?n=3',
        poster: [
          {
            videoSrc: `${staticUrl}/video/developers_nikea_house_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/nikea_house/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/developers_nikea_house_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/nikea_house/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/developers_nikea_house_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/developers/nikea_house/photo/photo3.webp`,
          },
        ],
      },
    ],
  },
  {
    name: 'offer_prod',
    content: [
      {
        id: 1,
        title: 'David Phillips',
        description:
          'offer_prod_desc1',
        images: [
          `${staticUrl}/images/offer/gallery/manufacturers/david_phillips/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/manufacturers/david_phillips/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/manufacturers/david_phillips/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/manufacturers_david_phillips_1.mp4`],
          [`${staticUrl}/video/manufacturers_david_phillips_2.mp4`],
          [`${staticUrl}/video/manufacturers_david_phillips_3.mp4`],
        ],
        videoMobile: [
          [
            `${staticUrl}/video/manufacturers_david_phillips_1_mobile.mp4`,
          ],
          [
            `${staticUrl}/video/manufacturers_david_phillips_2_mobile.mp4`,
          ],
          [
            `${staticUrl}/video/manufacturers_david_phillips_3_mobile.mp4`,
          ],
        ],
        tour: '/tours/Tour_from_25.01.2024_13-00-31-473/index.htm?n=1',
        poster: [
          {
            videoSrc: `${staticUrl}/video/manufacturers_david_phillips_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/david_phillips/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/manufacturers_david_phillips_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/david_phillips/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/manufacturers_david_phillips_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/david_phillips/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 2,
        title: 'Smith Lights',
        description:
          'offer_prod_desc2',
        images: [
          `${staticUrl}/images/offer/gallery/manufacturers/smith_lights/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/manufacturers/smith_lights/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/manufacturers/smith_lights/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/manufacturers_smith_lights_1.mp4`],
          [`${staticUrl}/video/manufacturers_smith_lights_2.mp4`],
          [`${staticUrl}/video/manufacturers_smith_lights_3.mp4`],
        ],
        videoMobile: [
          [
            `${staticUrl}/video/manufacturers_smith_lights_1_mobile.mp4`,
          ],
          [
            `${staticUrl}/video/manufacturers_smith_lights_2_mobile.mp4`,
          ],
          [
            `${staticUrl}/video/manufacturers_smith_lights_3_mobile.mp4`,
          ],
        ],
        tour: '/tours/Tour_from_20.02.2024_17-52-59-271/index.htm?n=1',
        poster: [
          {
            videoSrc: `${staticUrl}/video/manufacturers_smith_lights_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/smith_lights/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/manufacturers_smith_lights_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/smith_lights/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/manufacturers_smith_lights_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/smith_lights/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 3,
        title: 'DWFI',
        description:
          'offer_prod_desc3',
        images: [
          `${staticUrl}/images/offer/gallery/manufacturers/dwfi/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/manufacturers/dwfi/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/manufacturers/dwfi/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/manufacturers_dwfi_1.mp4`],
          [`${staticUrl}/video/manufacturers_dwfi_2.mp4`],
          [`${staticUrl}/video/manufacturers_dwfi_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/manufacturers_dwfi_1_mobile.mp4`],
          [`${staticUrl}/video/manufacturers_dwfi_2_mobile.mp4`],
          [`${staticUrl}/video/manufacturers_dwfi_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_19.02.2024_18-46-14-476/index.htm?n=2',
        poster: [
          {
            videoSrc: `${staticUrl}/video/manufacturers_dwfi_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/dwfi/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/manufacturers_dwfi_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/dwfi/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/manufacturers_dwfi_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/dwfi/photo/photo3.webp`,
          },
        ],
      },
      {
        id: 4,
        title: 'Minotti',
        description:
          'offer_prod_desc4',
        images: [
          `${staticUrl}/images/offer/gallery/manufacturers/minotti/photo/photo1.webp`,
          `${staticUrl}/images/offer/gallery/manufacturers/minotti/photo/photo2.webp`,
          `${staticUrl}/images/offer/gallery/manufacturers/minotti/photo/photo3.webp`,
        ],
        video: [
          [`${staticUrl}/video/manufacturers_minotti_1.mp4`],
          [`${staticUrl}/video/manufacturers_minotti_2.mp4`],
          [`${staticUrl}/video/manufacturers_minotti_3.mp4`],
        ],
        videoMobile: [
          [`${staticUrl}/video/manufacturers_minotti_1_mobile.mp4`],
          [`${staticUrl}/video/manufacturers_minotti_2_mobile.mp4`],
          [`${staticUrl}/video/manufacturers_minotti_3_mobile.mp4`],
        ],
        tour: '/tours/Tour_from_19.02.2024_18-36-16-235/index.htm?n=1',
        poster: [
          {
            videoSrc: `${staticUrl}/video/manufacturers_minotti_1.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/minotti/photo/photo1.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/manufacturers_minotti_2.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/minotti/photo/photo2.webp`,
          },
          {
            videoSrc: `${staticUrl}/video/manufacturers_minotti_3.mp4`,
            value: `${staticUrl}/images/offer/gallery/manufacturers/minotti/photo/photo3.webp`,
          },
        ],
      },
    ],
  },
];
</script>

<style scoped lang="scss">
h1 {
  @include headline-h1;
  text-align: center;
  margin: 0px;
  margin-top: $m-4;
  margin-bottom: $m-20;

  @media (max-width: $md) {
    margin-top: $m-2;
    margin-bottom: $m-5;
  }
}
p {
  @include subtitle-fs-14-fw-400-gray-200;
  margin: 0px;
  text-align: center;
}
.gallery {
  height: 100%;
  width: 100%;
  padding-top: $m-25;
  margin-bottom: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    color: #64686e;
  }

  .wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: $m-34;

    @media (max-width: $md) {
      margin-bottom: $m-10;
    }
  }

  @media (min-width: 2000px) {
    min-height: 1000px;
  }

  @media (max-width: $lg) {
    margin-top: $m-0;
    padding-top: $m-10;
  }
  @media (max-width: $md) {
    gap: $g-5;
    padding-top: $m-5;
  }
}
</style>
